import React from "react";
import ReactDOM from "react-dom/client";
// Global tokens and shared component styles load first, so page/component styles can override them.
import "./assets/styles/app.scss";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
